import Vue from 'vue';
import VueRouter from 'vue-router';
import VeeValidate, { Validator } from 'vee-validate';
const zh = require('vee-validate/dist/locale/pt_BR');

import router from '@/Support/Http/Router';
import App from './App.vue';

import store from '@/Support/Store/Vuex';

Vue.config.productionTip = true;

Vue.use(VueRouter);
Vue.use(VeeValidate);

Validator.localize('pt_BR', zh);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
